export default {
	setSelectedClassLevel(context, payload) {
		context.commit('SET_SELECTED_CLASS_LEVEL', payload);
	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-level/actions.js